import { Routes } from '@angular/router';
import { provideOnboardingDomain } from '@zero/onboarding/domain';
import { provideTagsDomain } from '@zero/tags/domain';
import { WatchlistPageComponent } from './pages/watchlist-page/watchlist-page.component';

export const WATCHLIST_WEB_ROUTES: Routes = [
  { path: '', component: WatchlistPageComponent, providers: [provideTagsDomain(), provideOnboardingDomain()] },
];
